/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  root: 'https://api.mavilleapp.com',
  //root: 'http://localhost:8082',  
  mapbox: {
    accessToken: 'pk.eyJ1Ijoic2FuZ2V2YW4iLCJhIjoiY2s3ZHhxYTFxMDBiZTNmbW93Nms5MmFwaSJ9.ZRhjV4Iy9LqM4WZKUzJ2Dw'
  }
};
